import { useMutation, useQueryClient } from 'react-query'
import { apiFetch } from 'lib/action-helpers'

import { policyPaths as paths, NOTIFICATION_POLICY } from './index'
import { useOrganization } from 'hooks/context/organization-context'

const updateNotificationPolicy = async (account, policy, payload) => {
  const data = await apiFetch(paths.policy(account, policy), { method: 'PUT', body: JSON.stringify(payload) })
  return data?.data
}

export const useUpdateNotificationPolicyQuery = () => {
  const queryClient = useQueryClient()
  const { account } = useOrganization()

  return useMutation(
    ({ policy, payload }) => updateNotificationPolicy(account.id, policy, payload),
    {
      onMutate: ({ policy, payload }) => {
        const previousPolicy = queryClient.getQueryData([NOTIFICATION_POLICY, policy])

        const newPolicy = { ...previousPolicy, name: payload.name }
        queryClient.setQueryData([NOTIFICATION_POLICY, policy], newPolicy)

        return { previousPolicy }
      },
      onError: (err, newItem, context) => {
        if (err) {
          queryClient.setQueryData([NOTIFICATION_POLICY, context.previousPolicy.id], context.previousPolicy)
        }
      },
      onSuccess: (data) => {
        queryClient.setQueryData([NOTIFICATION_POLICY, data?.id], data)
      }
    }
  )
}
